<template>
  <div class="echarts">

    <div class="map-area" ref="dotMap"></div>

    <div class="map-choose">
      <span v-for="(item,index) in parentInfo" :key="item.code">
        <span class="choose-name" @click="chooseArea(item,index)">{{item.cityName=='全国'?'中国':item.cityName}}</span>
        <span class="choose-icon" v-show="index+1!=parentInfo.length">&nbsp;</span>
      </span>
    </div>


  </div>
</template>

<script>
  // import echarts from 'echarts'
  import resize from "./mixins/resize";
  import geo from "./options/geo"
  import toolbox from "./options/toolbox"
  import tooltip from './options/tooltip'
  import series from './options/series'

  export default {
    mixins: [resize],
    data() {
      return {
        myCharts: null,
        geoJson: {
          features: []
        },
        parentInfo: [{
          cityName: "全国",
          code: 100000
        }],
        adcCodeMap:{},
        repairPointList:[]
      }
    },
    mounted() {

      this.$get("/app/repairpoint/getList").then(suc=>{
        this.repairPointList = suc.data
      })

      this.getGeoJson(100000)
    },
    methods: {
      getGeoJson(adcode) {
        let that = this;
        AMapUI.loadUI(["geo/DistrictExplorer"], DistrictExplorer => {
          var districtExplorer = new DistrictExplorer();
          districtExplorer.loadAreaNode(adcode, function (error, areaNode) {
            if (error) {
              console.error(error);
              return;
            }

            console.log(areaNode)

            let Json = areaNode.getSubFeatures();
            if (Json.length > 0) {
              that.geoJson.features = Json;
            } else if (Json.length === 0) {
              that.geoJson.features = that.geoJson.features.filter(
                item => item.properties.adcode == adcode
              );
              if (that.geoJson.features.length === 0) return;
            }
            that.geoJson.features.map(item=>that.adcCodeMap[item.properties.name]=item.properties.adcode)
            console.log(that.geoJson.features)
            console.log(that.adcCodeMap)
            that.getMapData();
          });
        });
      },
      //获取数据
      getMapData() {

        var province=""
        if(this.parentInfo.length==2){
          province=this.parentInfo[1].cityName
        }
        this.$get("/app/repairpoint/getLocations?province="+province).then(suc=>{
          this.initEcharts(suc.data)
        })


        /**
         * mapData 格式
         * name:北京
         * cityCode:120000
         * value:[经度，纬度，值]
         */


      },
      initEcharts(data) {

        console.log("init chart")
        console.log(data)

        let repairPointData = []
        let operationCenterData = []
        data.rp.forEach(item=>{
          repairPointData.push({
            name:item.name,
            time:item.time,
            cityCode:"123",
            value:[item.longi,item.lati,item.time]
          })
        })

        data.oc.forEach(item=>{
          operationCenterData.push({
            name:item.name,
            cityCode:"123",
            value:[item.longi,item.lati]
          })
        })

        this.myChart = echarts.init(this.$refs.dotMap)
        echarts.registerMap('Map', this.geoJson) //注册
        this.myChart.setOption({
            tooltip: tooltip,
            toolbox: toolbox,
            geo: geo.geo(this.parentInfo.length==1),
            series: [
              series.getRepairPoint(repairPointData),
              series.getOperationCenter(operationCenterData)
            ]
          },
          true
        )

        let that = this;
        this.myChart.off("click");
        this.myChart.on("click", params => {

          if(that.parentInfo.length==2){
            return;
          }

          console.log(that.adcCodeMap)
          console.log(params)
          if(params.componentType == "geo"){
            that.showProvince(params.name)
            return
          }

          return

          if (!params.data) {
            return
          }
          if ( that.parentInfo[that.parentInfo.length - 1].code == params.data.cityCode ) {
            return;
          }
          let data = params.data;
          that.parentInfo.push({
            cityName: data.name,
            code: data.cityCode
          });
          that.getGeoJson(data.cityCode);
        });
      },

      showProvince(province){
        let that = this
        let cityCode = that.adcCodeMap[province]
        if ( that.parentInfo[that.parentInfo.length - 1].code == cityCode ) {
          return;
        }
        that.parentInfo.push({
          cityName: province,
          code: cityCode
        });
        that.getGeoJson(cityCode);
      },

      //选择切换市县
      chooseArea(val, index) {
        if (this.parentInfo.length === index + 1) {
          return
        }
        this.parentInfo.splice(index + 1)
        this.getGeoJson(this.parentInfo[this.parentInfo.length - 1].code);

      }
    }
  }
</script>
<style  scoped>
  .echarts {
    position: relative;
  }

  .map-area{
    width: 100%;
    height:100%;
    position: absolute;
  }

  .map-choose {
    position: absolute;
    left: 20%;
    top: 80px;
    color: #eee;
  }

  .choose-name{
    border: 1px solid #FFF;
    cursor: pointer;
    border-radius: 3px;
    padding: 5px 10px;
    opacity: 0.6;
  }

  .choose-name:hover{
    opacity: 1;
  }



</style>



// WEBPACK FOOTER //
// src/views/home/board/AMapBoard.vue